import React from 'react';
// import ReactMarkdown from 'react-markdown';
import parseHTML from 'html-react-parser';

const Text = ({data, className, style}) => {
    if(data != null){
        if(data !== ''){
            return (
                <p className={className} style={style}>
                    {/* {data} */}
                    {parseHTML(data)}
                    {/* <ReactMarkdown>{data}</ReactMarkdown> */}
                </p>
            )
        }
        else{
            return (<></>);
        }
    }
    else{
        return (<></>);
    }
}

export default Text;